import { Observable } from 'rxjs';
import { mapTo, switchMap } from 'rxjs/operators';

import { AuthService } from '../../../auth/auth.service';
import { catchErrorLogRet } from '../../../common/rest.operators';
import { epicDependencies } from '../../../store';
import { Preset, PresetService } from '../../backend';

import { createParams } from './create-params.function';
import { loadPresets } from './load-presets.function';

export function createPreset(name: string): Observable<Preset | null> {
    const authService = epicDependencies.injector.get<AuthService>(AuthService);
    const presetService =
        epicDependencies.injector.get<PresetService>(PresetService);

    const bp = createParams();
    const preset: Preset = {
        presetId: null,
        presetName: name,
        userId: authService.user.id,
        parameters: JSON.stringify(bp),
        createdOn: null,
        updatedOn: null,
    };

    return presetService.create(preset).pipe(
        catchErrorLogRet(null),
        switchMap((ret) => loadPresets().pipe(mapTo(ret))),
    );
}
